import { render } from "./AudienceOrNotSettingV2.vue?vue&type=template&id=5d7a569c"
import script from "./AudienceOrNotSettingV2.vue?vue&type=script&lang=ts"
export * from "./AudienceOrNotSettingV2.vue?vue&type=script&lang=ts"
script.render = render

export default script